import { Injectable } from "@angular/core";
import { LoginUserServiceBase } from "../interfaces/login-user-contract.service";

@Injectable({
  providedIn: "root"
})
export class LoginUserOfflineService extends LoginUserServiceBase {
  constructor() {
    super();
  }

  protected async loadUserProfile(): Promise<void> {
    // There is no profile in offline mode but the contract required an implementation.
  }
}
